module.exports = __webpack_public_path__ + "static/media/home-composition2.9ccbc798.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home-composition2.jpg
// module id = 1264
// module chunks = 37